module.exports = __webpack_public_path__ + "img/aeroland-client-logo-06-hover.d79579e8.png";